{
  "list": {
    "crumb": "Stoppages List",
    "up": "UP",
    "down": "DOWN",
    "available": "Available",
    "zeroDownHours": "0.0h",
    "verificationSubject": "stoppage"
  },
  "columns": {
    "setAvailable": "Set Avail'",
    "breakdownCode": "Breakdown Code",
    "repairsFaults": "Repairs/Faults",
    "workOrder": "Work Order",
    "dateIn": "Date In",
    "timeIn": "Time In",
    "timeOut": "Time Out",
    "downHours": "Down Hrs",
    "thisShift": "This Shift",
    "incident": "Incident",
    "whoWorkedOnIt": "Who worked on it",
    "bookedUpBy": "Booked Up by"
  },
  "filters": {
    "downAndUp": "Down & Up",
    "down": "Down",
    "jobType": "Job Type",
    "needsChecking": "Needs Checking",
    "needsCheckingTitle": "Show only stoppages the telemetry recorded that nobody has checked yet"
  },
  "messages": {
    "invalidStoppage": "Invalid stoppage selected, please try again",
    "invalidSubType": "Invalid stoppage subtype selected, please try again",
    "statusUpdated": "Status updated",
    "updated": "Stoppage updated successfully",
    "updateFailed": "Stoppage update failed",
    "updatedInPastShift": "Stoppage information for {{machine}} has been updated in the past shift",
    "machineUpdated": "{{machine}} has been updated",
    "added": "A new stoppage for {{machine}} has been added",
    "deletedFor": "A stoppage entry for {{machine}} has been deleted",
    "deleted": "A stoppage entry has been deleted"
  },
  "setAvailable": {
    "title": "Mark {{machine}} as \"Available\"?",
    "body": "The 'time available' will be marked as now."
  },
  "cells": {
    "selectStoppageType": "Select Stoppage Type",
    "selectLocation": "Select Location",
    "noRepairsFaults": "No Repairs/Faults",
    "noWorkOrder": "No Work Order",
    "notSpecified": "Not Specified"
  },
  "images": {
    "title": "Stoppage Images",
    "none": "No images found",
    "upload": "Upload Image",
    "uploaded": "Image uploaded successfully",
    "uploadFailed": "Error uploading image, please try again",
    "invalidImage": "Invalid image selected, please try again",
    "deleted": "Image deleted successfully",
    "deleteFailed": "Error deleting image, please try again",
    "deleteImage": "Delete image {{fileName}}",
    "offline": "Images are not available offline",
    "view": "View uploaded images",
    "noneYet": "No images uploaded yet"
  },
  "uncheckedGps": {
    "intro": "Non Operating Delay, Standby and Unclassified stoppages the FMS raised on this shift that nobody has confirmed yet, oldest first. Give an Unclassified one a type before marking it checked. Maintenance Down and Preventative Maintenance are not shown here - those already carry a work order once raised or reviewed.",
    "typeSubType": "Type / Sub Type",
    "started": "Started",
    "openFor": "Open For",
    "hours": "h",
    "markChecked": "Mark checked",
    "markedChecked": "{{machine}} marked as checked",
    "markedCheckedStoppage": "Stoppage marked as checked",
    "updated": "{{machine}} updated",
    "updatedStoppage": "Stoppage updated",
    "lockedShift": "Started on a locked shift; unlock that shift to check it",
    "chooseTypeFirst": "Choose a type first"
  }
}
